// extracted by mini-css-extract-plugin
export default {"checkableTag":"ChipsFilter_checkableTag__t6oSl","tag":"ChipsFilter_tag__1oSp7"};